import { useContext } from "react"
import { PromosThemesContext } from "modules/promos/contexts/PromosTheme"

export const usePromosTheme = () => useContext(PromosThemesContext)
